$( window ).load(function() {
    $(".zmdi-search").on("click",function(){
      if ($(".new_search_outer").hasClass("active"))
      {
       $(".new_search_outer").removeClass("active");  
      }
      else{
        $(".new_search_outer").addClass("active");
      }
  });
});


/* New JS 19-6-18 */
// burger menu start
$(document).ready(function(){
  
    $("#hide_burger").click(function(){
        $(".burger_menu_drop").hide();
		$(".burger_menu").removeClass("open_burger");

		
    });
    $("#show_burger").click(function(){
        $(".burger_menu_drop").show();
		 $(".burger_menu").addClass("open_burger");
		
    });
  
  
    $('.ProductRelatedCrowsel').owlCarousel({
      items:10,
      loop:false,
      nav:true,
      navText: ['<i class="icon-left-open"></i>','<i class="icon-right-open"></i>'],
      arrow:true,
      //autoplay:true,
      responsive:{
        0:{
          items:1
        },
        600:{
          items:2
        },
        1000:{
          items:5
        }
      }
    }); // end owl product page
    
  
	
});
// burger menu end

// mission icon  owlCarousel start
/*$(document).ready(function(){
$('.owl-carousel').owlCarousel({
		items:6,
		loop:true,
		nav:true,
		arrow:true,
		//autoplay:true,
    responsive:{
        0:{
            items:6
        },
        600:{
            items:2
        },
        1000:{
            items:6
        }
    }
})
});*/
// mission icon  owlCarousel end

// search toggle start
$(document).ready(function(){
    $(".search_toggle").click(function(){
        $(".open_search_panel").slideToggle();
	
    });
});
// search toggle end

// user_account start
$(document).ready(function(){
    $(".user_account").click(function(){
        $(".user_account_panel").slideToggle();
	
    });
});
// user_account end

// Mobile navigation start
function openNav() {
    document.getElementById("mySidenav").style.width = "75%";
    document.getElementById("slide_class_nav").style.marginLeft = "75%";
    document.body.style.backgroundColor = "rgba(0,0,0,0.4)";
}

function closeNav() {
    document.getElementById("mySidenav").style.width = "0";
    document.getElementById("slide_class_nav").style.marginLeft= "0";
    document.body.style.backgroundColor = "white";
}
// Mobile navigation end

/*search */
   $(document).ready(function() {
        $(".search12").click(function() {
            $(".cust_show_search_box").toggle();
        });

    });

/*
$(document).ready(function(){
  console.log("REady");
  $("#AddToCart-product-template").click(function(e){
    e.preventDefault();
    console.log("Click");
     var variant_id = $(".cust_veriant").text();
  
  console.log("variant_id")
    
   });
        });


*/


$(document).ready(function(){
  
  $(".swatch-element").on('click', function(){
    
    $(".cust-content").css("display","none");
    $(".add-to-cart").removeClass("disable");
    
    //location.reload();

  });
  
  $('.swatch-element .cust-swatch').on('change', function(){
    setTimeout(function(){ 
      if($('[name="id"]').val() != ""){
         //location.reload();
      }
    }, 1);
  });
  
});